export default {
	init() {
		if (!document.querySelector(".video-wrap")) {
			return;
		}

		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const video = entry.target.querySelector("video");

					if (!video) {
						return;
					}

					if (entry.intersectionRatio < 0.09) {
						video.pause();
					} else {
						const playPromise = video.play();

						if (playPromise !== undefined) {
							playPromise.catch(() => {});
						}
					}
				});
			},
			{
				root: null,
				threshold: [0, 0.2, 0.3, 0.7, 0.8, 1],
			},
		);

		this.videoWraps = document.querySelectorAll(".video-wrap");

		this.videoWraps.forEach((videoWrap) => {
			this.observer.observe(videoWrap);
		});
	},

	destroy() {
		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}

		if (this.videoWraps) {
			this.videoWraps.forEach((videoWrap) => {
				const video = videoWrap.querySelector("video");

				if (video) {
					video.pause();
					video.removeAttribute("src");
					video.load();
				}
			});
		}

		this.videoWraps = null;
	},
};
